import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, Data } from '@angular/router';

import { AppExperienceService, IWebViewFeature, webViewFeatures } from '../services/app-experience.service';
import { isEmbeddedWebView } from '../lib/boot-utils';

interface IWebViewAccessGuardData {
  featureName: string;
}

@Injectable()
export class WebViewAccessGuard {
  constructor(
    private router: Router,
    private appExperience: AppExperienceService,
  ) {}

  public canActivate(route: ActivatedRouteSnapshot): boolean {
    const data: Data = route.data;
    const config: IWebViewAccessGuardData = data.webViewAccessGuard;
    const featureName: string = config.featureName;

    const featureConfig: IWebViewFeature =
      webViewFeatures.find((feature: IWebViewFeature): boolean => feature.name === featureName);
    if (featureConfig) { return featureConfig.canLoad(this.appExperience); }

    if (isEmbeddedWebView()) return true;
    this.router.navigate(['/']);
    return false;
  }
}
